import { useDrop } from 'react-dnd';

import DraggablePlayer from '@/components/molecules/DraggablePlayer';
import { TeamPlayerInfo } from '@/lib/types';
import { ItemType } from '@/lib/types';

interface DroppableAreaProps {
	droppedPlayers: TeamPlayerInfo[];
	onDrop: (player: TeamPlayerInfo) => void;
}

export default function DroppableArea({ droppedPlayers, onDrop }: DroppableAreaProps) {
	const [{ isOver }, drop] = useDrop({
		accept: ItemType.PLAYER,
		drop: (item: TeamPlayerInfo) => onDrop(item),
		collect: (monitor: any) => ({
			isOver: !!monitor.isOver()
		})
	});

	return drop(
		<div
			className={`flex min-h-[342px] w-[390px] flex-wrap content-start gap-4 rounded-lg border border-gray-300 p-4 ${isOver ? 'bg-gray-100' : ''}`}
		>
			{droppedPlayers.length !== 0 ? (
				droppedPlayers.map((player) => <DraggablePlayer key={player.uuid} player={player} />)
			) : (
				<div className="flex size-full items-center justify-center text-darkorange-600">
					<p>Drag and drop all players here</p>
				</div>
			)}
		</div>
	);
}
